import { Component, OnInit, EventEmitter } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';
import { StorageService } from 'src/app/services/storage.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { MatDialog } from '@angular/material/dialog';
import { PassageirosModal } from 'src/app/components/minhas-viagens/passageiros-modal/passageiros-modal.component';

declare var window:any;

@Component({
  selector: 'minhas-viagens-page',
  templateUrl: './minhas-viagens-page.component.html',
  styleUrls: ['./minhas-viagens-page.component.scss']
})
export class MinhasViagensPage implements OnInit {

  public loader   = false;
  private apelido = "minhas-viagens"; 
  public response:any = {
    data: "",
    status: null
  };
  public page              = null;
  public fotos             = []; 
  public params:any        = {};
  public valores           = [];
  public clientes          = [];
  public itensBreadcrumbs  = []; 
  public usuario           = null;
  public programacao       = [];
  public updateAtualizacao = new EventEmitter();

  constructor(
    private api:ApiService,
    private app: AppService,
    private storage: StorageService,
    private usuarioSerice: UsuarioService,
    private dialog: MatDialog
  ){ } 

  /**
   * 
   * 
   * 
   * 
   */
  getData(){

    try{
      
      this.loader = true; 
      
      this.api.conteudo().page(this.apelido).subscribe(response => {
      
        this.loader = false;
      
        if(response.status == 1){ 
                
          if(typeof(response.data.page) != "undefined"){
                  
            this.page        = typeof(response.data.page.data[0]) != "undefined" ? response.data.page.data[0] : response.data.page.data;
            this.params      = JSON.parse(this.page.params);
            this.usuario     = response.data.page.usuario; 
            this.programacao = response.data.page.programacao; 
            this.storage.setUsuario(this.usuario);  

            this.app.setMetaDados(this.page.meta_title,this.page.meta_description,this.page.meta_keywords);
              
          }
          this.response = { 
            data: "",
            status: 1
          }
      
      
        }else{
          this.response = {
            data: response.data,
            status: 500
          }
        }
      
      },(err) =>{
      
        this.loader = false;
        this.response = err;
      
      });
    
    }catch(e){
      
    }

  }
  /***
  * 
  * Seta os breadcrumbs
  * 
  */
  setItensBreadcrumbs(){

    this.itensBreadcrumbs.push({
      text: "Minhas Viagens"
    });

  }
  /**
   * 
   * On Data
   * 
   */
  onData(){

    this.usuarioSerice.emitUsuarioLogin.subscribe(usuario => {

      this.usuario = usuario; 
      this.getData(); 

    });

    this.updateAtualizacao.subscribe(data => { 

      for(let i=0;i < this.programacao.length;i++){

        if(data.id == this.programacao[i].id){ 

          this.programacao[i].solicitar_passageiros = true;
          break;
          
        }

      }

    });

  }
  /**
   * 
   * Click Roteiro
   * 
   */
  _clickRoteiro(programacao){

    if(!programacao.solicitar_passageiros){

      this.app.info("Você precisa informar os passageiros para obter o roteiro dos serviços.");
      return false;
    }

    window.location.assign("/api/site/componentes/pagamento/download-confirmacao/"+programacao.hash)
  
  }
  /**
   * 
   * Click passageiros
   * 
   */
  _clickPassageiros(programacao){

    this.dialog.open(PassageirosModal,{
      width: "800px",
      height: "auto",
      data: {
        programacao: programacao,
        updateStatusProgramacao: this.updateAtualizacao
      }
    });

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit():void{
    this.app.toTop();
    this.getData(); 
    this.setItensBreadcrumbs();
    this.onData();
  }

}
